import { useMatches } from '@remix-run/react'
import { computeHeaderSimple, type HeaderMatch } from '~/utils'

const useHeaderSimple = (): boolean => {
  const matches = useMatches() as HeaderMatch[]
  return computeHeaderSimple(matches)
}

export default useHeaderSimple
